export default "__VITE_ASSET__BIv4YJmD__"